import script from "./ServiceMixin.vue?vue&type=script&lang=js"
export * from "./ServiceMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__